import React, {useEffect, useState} from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

const InputUserPwCheck = ({
                            propLabel = '비밀번호 확인',
                            propPassword,
                            propError = "",
                            propOnChange = null,
                          }) => {
  useEffect(() => {
    if (propError !== "") {
      setError(propError);
    }
  }, [propError]);

  const [error, setError] = useState();

  const checkPassword = (e) => {
    const pw = e.target.value;
    if (pw === propPassword) {
      setError('사용 가능합니다.');
      propOnChange(e);
    } else {
      setError('비밀번호를 확인해주세요.')
    }
  };

  return (
      <>
        <Form.Group as={Row} controlId='userPwCheck'>
          <Form.Label column md={3} className={'label text-end fw-bold'}>
            <span className={"text-danger"}>* </span>{propLabel}
          </Form.Label>
          <Col md={9} className={''}>
            <Form.Control
                type="password"
                className={"input input-pw"}
                onChange={checkPassword}
                required
            />
          </Col>
        </Form.Group>
        {error !== "" ? (
            <Col md={12} className={"error text-center text-danger"}>
              {error}
            </Col>
        ) : ("")}
      </>
  );
};

export default InputUserPwCheck;